const getStyles = () => {
  return {
    rootWraper: {
      margin: '10px 0',
      textAlign: 'center'
    },
    basicInput: {
      '& .MuiInputBase-input': {
        pt: '10px',
        pb: '10px'
      },
      '&:focus-within .MuiOutlinedInput-notchedOutline': {
        borderColor: `#607d8b !important`,
        borderWidth: '1.5px !important'
      },
      '& .MuiInputLabel-root': {
        color: '#666666' // Default label color
      }
      /* '.MuiOutlinedInput-notchedOutline': {
        borderColor: `${NEUTRAL_GRAY} !important`,
        borderWidth: '1.5px !important'
      },
      '& .MuiInputAdornment-root': {
        minWidth: '15px',
        textAlign: 'center',
        display: 'contents'
      } */
    },
    sectionTitle: {
      fontFamily: 'Raleway',
      fontSize: '2rem',
      color: '#616161',
      textAlign: 'center'
    },
    sectionDescription: {
      color: '#3f3f3f',
      fontSize: '18px',
      padding: '20px'
    },
    sectionDiverder: {
      borderRight: '1px solid #9e9e9e'
    },
    iconContainer: {
      display: 'flex',
      alignItem: 'center',
      justifyContent: 'center'
    },
    innerTitle: {
      fontFamily: 'Raleway',
      fontSize: '1.5rem',
      color: '#607D8B',
      textAlign: 'center',
      fontWeight: '500'
    },
    iconSpacing: {
      marginRight: '20px'
    },
    adressDetails: {
      fontFamily: 'Inter',
      fontSize: '16px',
      color: '#3f3f3f'
    },
    removeAddressSpacing: {
      margin: 0,
      padding: 0
    },
    addFontStyle: {
      fontStyle: 'italic'
    }
  };
};

export default getStyles;
